<template>
  <div>
      <b-modal id="log_modal"  size="lg" scrollable title="DHL Request Log History" ok-only ok-title="Close" ok-variant="danger">

          <div class="logContainer" v-if="logs.length > 0">
            <div class="single_log m-b-30" v-for="log in logs" v-bind:key="log.id">
              <h4 class="text-success">{{ log.requestType }}</h4>
              <tree-view :data="log.requestResponse" :options="{maxDepth: 1}" class="m-b-30"></tree-view>
              <div class="m-l-60">
                <h4 class="text-danger">PARENT RESPONSE</h4>
                <tree-view :data="log.parent.requestResponse" :options="{maxDepth: 1}"></tree-view>
              </div>
            </div>
          </div>
          <div v-else>
            <b-alert show>No Logs Found.</b-alert>
          </div>
      </b-modal>
  </div>
</template>

<script>
 import EventBus from '../../EventBus';
 import OrdersService from '../../services/orders.service';
 
  export default {
    data(){
      return {
        orderId: '',
        logs: []
      }
    },
     mounted(){
       EventBus.$on('orders.show-logs', (orderId) => {
          this.orderId = orderId;
          this.fetchLogs()
       })
     },
     methods: {
        fetchLogs(){
          OrdersService.getLogs(this.orderId)
            .then(response => { 
              this.logs = response.data.logs;
              console.log(response.data)})
            .catch(errors => console.log(errors.response.data));
        }
     },
     beforeDestroy(){
        EventBus.$off('orders.show-logs');
     }
  }
</script>

<style lang="scss" scoped>
  .single_log{
    border: 1px solid rgb(255, 223, 134);
    background-color: rgb(255, 244, 214);
    padding:30px;
    border-radius: 5px;
  }
</style>